import {
  Briefcase,
  CalendarDays,
  GraduationCap,
  Map,
  MessagesSquare,
  Rss,
  UserCircle,
  Wrench,
} from "lucide-react";

export const communityFeatures = [
  {
    title: "community.features.profile.title",
    description: "community.features.profile.description",
    icon: UserCircle,
    color: "text-nexus-teal",
    bgColor: "bg-nexus-teal/10",
  },
  {
    title: "community.features.feed.title",
    description: "community.features.feed.description",
    icon: Rss,
    color: "text-nexus-yellow",
    bgColor: "bg-nexus-yellow/10",
  },
  {
    title: "community.features.connections.title",
    description: "community.features.connections.description",
    icon: MessagesSquare,
    color: "text-nexus-red",
    bgColor: "bg-nexus-red/10",
  },
  {
    title: "community.features.mentorship.title",
    description: "community.features.mentorship.description",
    icon: GraduationCap,
    color: "text-purple-600",
    bgColor: "bg-purple-100 dark:bg-purple-950/40",
  },
];

export const platformModules = [
  { label: "community.modules.roadmaps", icon: Map },
  { label: "community.modules.tools", icon: Wrench },
  { label: "community.modules.events", icon: CalendarDays },
  { label: "community.modules.jobs", icon: Briefcase },
];
